var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectOrangeTopaz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5133 2.48321C15.5304 0.500389 12.3219 0.500389 10.3414 2.48321L8.07032 4.7543L9.26562 5.94961L11.5367 3.67852C12.7976 2.41758 14.9258 2.28399 16.3179 3.67852C17.7125 5.07305 17.5789 7.19883 16.3179 8.45975L14.0469 10.7308L15.2445 11.9285L17.5156 9.65745C19.4937 7.67461 19.4937 4.46602 17.5133 2.48321ZM8.46402 16.316C7.20312 17.577 5.075 17.7106 3.68281 16.316C2.28828 14.9214 2.42187 12.7957 3.68281 11.5347L5.9539 9.26365L4.75625 8.06605L2.48515 10.3371C0.502344 12.3199 0.502344 15.5285 2.48515 17.5089C4.46797 19.4894 7.67656 19.4918 9.65702 17.5089L11.9281 15.2378L10.7328 14.0425L8.46402 16.316ZM4.1 2.90508C4.06476 2.87019 4.01717 2.85061 3.96757 2.85061C3.91798 2.85061 3.87039 2.87019 3.83515 2.90508L2.90703 3.83321C2.87213 3.86845 2.85256 3.91604 2.85256 3.96563C2.85256 4.01522 2.87213 4.06281 2.90703 4.09805L15.9008 17.0918C15.9734 17.1644 16.0929 17.1644 16.1656 17.0918L17.0937 16.1636C17.1664 16.091 17.1664 15.9714 17.0937 15.8988L4.1 2.90508Z",
    fill: "#FFC786"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectOrangeTopaz);
export default __webpack_public_path__ + "static/media/disconnect-orange-topaz.c389f5f587a57b7ba70d2a5ca6639e17.svg";
export { ForwardRef as ReactComponent };